import { Component, OnInit } from '@angular/core';
import { MonitorService } from 'src/Services/monitoring.service';
import { SharedService } from 'src/Services/shared.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'GMFProtections-Marketing';

  constructor(
    private myMonitoringService: MonitorService,
    private sharedService: SharedService
  ) {
    // this is for logging verification into App insights. 
    this.myMonitoringService.logPageView();
  }
    ngOnInit(): void {
    this.sharedService.randomString.next(uuidv4());
  }
}
